<template>
  <div>
    <div class="topModule">
      <div class="topNav">
        <el-tabs v-model="activeName">
          <el-tab-pane label="审核简历" name="first" class="tab-first">
            <div class="operate">
              <el-row>
                <el-col :span="20">
                  <el-form :inline="true" :model="formInline1" class="demo-form-inline" ref="formInline1" :rules="rules" @submit.native.prevent>
                    <el-form-item label="操作" prop="status">
                      <el-select v-model="formInline1.status" placeholder="请选择" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="时间" prop="date">
                      <el-date-picker v-model="formInline1.date" type="date" :picker-options="pickerOptions" placeholder="选择日期"  value-format="yyyy-MM-dd" @change="getTime" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="" prop="time">
                      <el-time-picker v-model="formInline1.time" v-bind:picker-options="{selectableRange:data}" placeholder="任意时间点" value-format="HH:mm:ss" @change="getTime1"  :disabled="boo">
                      </el-time-picker>

                    </el-form-item>
                    <el-form-item label="说点什么" prop="remark">
                      <el-input v-model="formInline1.remark" placeholder="说点什么" @focus="wirteRemark" id="remark" clearable></el-input>
                      <!--<el-button type="text" @click="wirteRemark" >说点什么</el-button>-->
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="onSubmit1('formInline1')">确定</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="4">
                  <div class="history" @click="showToggle">操作历史
                    <i class="el-icon-arrow-down"></i>
                  </div>
                </el-col>
              </el-row>
              <!--操作历史弹层-->
              <div class="middleModule" v-show="isShow">
                <div class="source">
                  <div>来源：{{laizi}}</div>
                  <div>上传时间：{{jianli_time}}</div>
                  <div>推荐人：{{recommand}}</div>
                </div>
                <div class="hisList">
                  <span>下面是对该简历的操作历史：</span>
                  <el-table :data="hisData" style="width: 100%">
                    <el-table-column prop="hisotry_name" label="操作人" align="left" width="120" ></el-table-column>
                    <el-table-column prop="history_time" label="操作时间" align="left" width="180"></el-table-column>
                    <el-table-column prop="newAction" label="干了什么" align="left" width="180"></el-table-column>
                    <el-table-column prop="history_talk" label="备注" align="left" width="600"></el-table-column>
                  </el-table>
                </div>
              </div>
              <!--操作历史弹层end-->
            </div>

          </el-tab-pane>
          <el-tab-pane label="补充信息" name="second" tab-click>
            <div class="info">
              <span>（以下信息均为必填）</span>
              <div class="formtable">
                <el-form :inline="true" :model="formInline2" ref="formInline2" :rules="srules" @submit.native.prevent>
                  <el-row>
                    <el-col :span="5">
                      <el-form-item label="姓名：" prop="name">
                        <el-input v-model="formInline2.name"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="手机：" prop="mobile">
                        <el-input v-model="formInline2.mobile" maxlength="11"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="年龄：" prop="age">
                        <el-input v-model.number="formInline2.age" type="age" maxlength="2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="学历：" prop="degree">
                        <el-input v-model="formInline2.degree" maxlength="2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="5">
                      <el-form-item label="性别：" prop="sex" >
                        <el-radio-group v-model="formInline2.sex">
                          <el-radio v-model="radio" label="男">男</el-radio>
                          <el-radio v-model="radio" label="女">女</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="邮箱：" prop="email">
                        <el-input v-model="formInline2.email"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="学校：" prop="school">
                        <el-input v-model="formInline2.school" maxlength="16"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item>
                        <el-button  @click="onSubmit2('formInline2')">确定</el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4"></el-col>
                  </el-row>
                </el-form>

              </div>

            </div>

          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

    <!--<div class="bottomModule"><img src="../assets/resume.png" alt="resumePic"></div>-->
    <!--<div class="bottomModule" v-html="imgHtml"></div>-->
    <div style="overflow:hidden;width:1585px;margin-left:150px">
      <iframe :src="url" frameborder="0" width="1600"  class="frame" id="iframepage" @load="changeFrameHeight"></iframe>
    </div>
    <!-- <iframe :src="url" frameborder="0" width="1600"  class="frame" id="iframepage" @load="changeFrameHeight"></iframe> -->

  </div>
</template>

<script>
import moment from 'moment'

// let moment = require("moment");
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (value) {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      boo: true,
      data: '',
      pickerOptions: {
        disabledDate: time => {
          let curDate = new Date()
          var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)
          return time.getTime() < preDate
        }
      },
      pickerOptions1: {
        selectableRange:
          new Date().getHours() +
          ':' +
          new Date().getMinutes() +
          ':' +
          new Date().getSeconds() +
          '-' +
          '23:59:59'
      },
      pickerOptions2: {
        selectableRange: '00:00:00-23:59:59'
      },
      pickerOptions3: { selectableRange: '' },
      url: '',
      imgHtml: '',
      jianli_id: sessionStorage.getItem('jianli_id'),
      formInline: {},
      radio: '1',
      activeName: 'first',
      value1: '',
      value2: '',
      input: '',
      options: [
        {
          value: '-1',
          label: '删除简历'
        },
        {
          value: '0',
          label: '未处理'
        },
        {
          value: '1',
          label: '可邀约'
        },
        {
          value: '2',
          label: '不合适'
        },
        {
          value: '3',
          label: '邀约'
        },
        {
          value: '4',
          label: '爽约'
        },
        {
          value: '5',
          label: '已面试'
        },
        {
          value: '6',
          label: '通过'
        },
        {
          value: '7',
          label: '发offer'
        },
        {
          value: '8',
          label: '放弃入职'
        },
        {
          value: '9',
          label: '入职'
        },
        {
          value: '10',
          label: '上传'
        },
        {
          value: '11',
          label: '内推'
        },
        {
          value: '12',
          label: '邀约失败'
        },
        {
          value: '-2',
          label: '不通过'
        },
        {
          value: '-3',
          label: '人才库'
        },
        {
          value: '10001',
          label: '修改'
        }
      ],
      value: '',
      isShow: false,
      tvalue: '',
      hisData: [],
      laizi: '',
      jianli_time: '',
      recommand: '',
      formInline1: {
        status: '',
        date: '',
        time: '',
        remark: ''
      },
      rules: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
        // time: [
        //   {
        //     required: true,
        //     message: "请选择具体时间",
        //     trigger: "change"
        //   }
        // ],
        // date: [
        //   {
        //     required: true,
        //     message: "请选择日期",
        //     trigger: "change"
        //   }
        // ]

        // remark: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
      },
      formInline2: {
        name: '',
        mobile: '',
        degree: '',
        sex: '',
        school: '',
        email: '',
        age: ''
      },
      srules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          },
          { required: true, message: '邮箱必须填写', trigger: 'blur' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        degree: [{ required: true, message: '请写上学历', trigger: 'blur' }],
        school: [
          { required: true, message: '请写上毕业学校', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '请填写年龄', trigger: 'blur' },
          { type: 'number', message: '年龄必须为数字值' }
        ]
      },
      content: ''
    }
  },
  created () {
    this.getJianLiDetail()
    this.getHistory()
  },
  watch: {
    'formInline1.date': function () {
      let self = this
      if (
        moment(self.formInline1.date).format('YYYY-MM-DD') ===
        moment(new Date()).format('YYYY-MM-DD')
      ) {
        self.data = this.pickerOptions1.selectableRange
      } else {
        self.data = this.pickerOptions2.selectableRange
      }
    },
    deep: true
  },
  methods: {
    showToggle: function () {
      this.isShow = !this.isShow
      if (this.isShow === true) {
        let self = this
        self.getHistory()
      }
    },
    getJianLiDetail () {
      let self = this
      // 封装的简历url，经常会跳去权限判断，弃用该接口
      // this.$axios
      //   .post("/api/zhaopin/zhiwei/jianliurl", {
      //     jianli_id: sessionStorage.getItem("jianli_id")
      //   })
      //   .then(function(res) {
      //     if (res.status === 200) {
      //       self.url = res.data.url;
      //     }
      //   });
      this.$axios
        .get('/api/zhaopin/zhiwei/jianli/view', {
          params: {
            i: sessionStorage.getItem('jianli_id')
          }
        })
        .then(function (res) {
          if (res.status === 200) {
            self.url =
              '/api/zhaopin/zhiwei/jianli/view?i=' +
              sessionStorage.getItem('jianli_id')
          }
        })
    },
    changeFrameHeight () {
      var ifm = document.getElementById('iframepage')
      ifm.height = document.documentElement.clientHeight
    },
    getHistory () {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/detail2', {
          jianli_id: sessionStorage.getItem('jianli_id')
        })
        .then(function (res) {
          self.laizi = res.data['jianli_laizi']
          self.jianli_time = res.data['jianli_time']
          self.recommand = res.data['recommand']
          self.hisData = res.data.data
          for (var i = 0; i < self.hisData.length; i++) {
            var action = self.hisData[i]['history_action']
            var time = self.hisData[i]['history_atime']
            self.hisData[i].newAction = action + '(' + time + ')'
          }
        })
    },
    onSubmit1 (formName) {
      let self = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/zhaopin/zhiwei/jianli/status2', {
              jianli_id: sessionStorage.getItem('jianli_id'),
              jianli_status_id: this.formInline1.status,
              action_time: this.formInline1.date + ' ' + this.formInline1.time,
              jianli_talk: this.formInline1.remark
            })
            .then(function () {
              self.$refs[formName].resetFields()
              self.getHistory()
            })
        }
      })
    },
    onSubmit2 (formData) {
      let self = this
      this.$refs[formData].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/zhaopin/jianli/detail/change2', {
              jianli_age: this.formInline2.age,
              jianli_id: sessionStorage.getItem('jianli_id'),
              jianli_name: this.formInline2.name,
              jianli_gender: this.formInline2.sex,
              jianli_xuexiao: this.formInline2.school,
              jianli_xueli: this.formInline2.degree,
              jianli_mobile: this.formInline2.mobile,
              jianli_email: this.formInline2.email
            })
            .then(function () {
              self.$refs[formData].resetFields()
            })
        }
      })
    },

    getTime (val) {
      let self = this
      self.formInline1.date = val
      if (self.formInline1.date) {
        self.boo = false
      }
    },
    getTime1 (val) {
      let self = this
      self.formInline1.time = val
    },
    wirteRemark () {
      let self = this
      document.getElementById('remark').blur()
      this.$prompt('说点什么', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showConfirmButton: false,
        showCancelButton: false,
        showClose: false,
        inputPattern: /^.{0,300}$/,
        inputErrorMessage: '字数必须在2~300',
        callback (action, instance) {
          if (action === 'cancel') {
            if (instance.inputValue) {
              self.formInline1.remark = instance.inputValue
              self.$message({
                type: 'success',
                message: '备注成功'
              })
            } else {
              self.$message({
                type: 'info',
                message: '取消输入'
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.topModule {
  margin: 0 auto;
  width: 1600px; // height: 148px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 10px 0px rgba(80, 80, 80, 0.1);
}

.operate {
  margin: 20px 0 36px 30px;
  padding-left: 10px;
  font-size: 14px;
}

.history {
  padding: 10px 35px;
  color: #1989fa;
  cursor: pointer;
}

.middleModule {
  margin: 0 auto;
  width: 1600px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 10px 0px rgba(80, 80, 80, 0.1);
}

.source {
  margin-left: 38px;
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}

.hisList {
  margin-top: 30px;
  margin-left: 38px;
  font-size: 14px;
}

.hisList span {
  color: #999999;
}

.bottomModule {
  position: relative;
  left: 50%;
  top: 20px;
  margin: 0 auto;
  transform: translate(-50%, 0);
  display: inline-block;
}

.info {
  margin-left: 38px;
}

.info span {
  display: block;
  color: #999999;
  font-size: 12px;
  margin-bottom: 15px;
}

.formtable {
  font-size: 14px;
  color: #333333;
  padding-right: 30px;
}
.frame {
  display: block;
  // overflow: hidden;
  margin: 0 auto;
  padding-top: 20px;
}
</style>
